import Sync from './containers/SyncContainer';

export default Sync;
